// extracted by mini-css-extract-plugin
export default {"option":"OptionList_option__xn5pT","selected":"OptionList_selected__m4yTG","option__text":"OptionList_option__text__U8Q5M","copy":"OptionList_copy__qzOr4"};